"use client"

import { usePathname, useSearchParams } from "next/navigation";

//#region [Props]
type ContextLessAdProps = {
    mobilePlacementId: string;
    desktopPlacementId?: string;
};
//#endregion

const BRAND = process.env.NEXT_PUBLIC_WEBSITE_BRAND;

/**
 * This is for ad placements that have to live outside of an ad context.
 */

//#region [Component]
export default function ContextLessAd(props: ContextLessAdProps) {
    if (BRAND === "kinodk") {
        return <KinoDkContextLessAd {...props} />
    }
    return null;
}
//#endregion

function KinoDkContextLessAd({ mobilePlacementId, desktopPlacementId }: ContextLessAdProps) {
    const pathname = usePathname();
    return <>
        <div key={`${pathname}-mobile`} id={mobilePlacementId} data-targetid="DK_top"></div>
        {desktopPlacementId && <div key={`${pathname}-desktop`} id={desktopPlacementId} data-targetid="DK_top"></div>}
    </>
}